import DisclaimerMainSection from "../PageElements/DisclaimerPageElement/DisclaimerMainSection";
import ConsultSection from "../PageElements/HomePageElements/ConsultSection";

export default function DisclaimerPage() {
    return (
        <>

            <DisclaimerMainSection/>
            {/* <ServiceSection /> */}
            <ConsultSection />
        </>
    )
}